import React from "react";

function SectionHeading({ id, label, title, description }) {
  return (
    <header className="section-heading" id={id}>
      {label && <span className="section-label">{label}</span>}
      <h2 className="section-title">{title}</h2>
      {description && <p className="section-desc">{description}</p>}
    </header>
  );
}

export default SectionHeading;
